// libraries
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
// our stuff
import './DotInspectionResultConfirmation.css';
import DotResult from './DotResult';
import Spinner from 'components/Spinner';

class DotInspectionResultConfirmation extends React.Component {                    
    render() {
		const messages = defineMessages({
			dot_inspection__title: {
                id: 'dot_inspection__title',
                description: 'DOT inspection title',
                defaultMessage: 'DOT annual vehicle inspection'
			},
			dot_inspection__edit_form: {
                id: 'dot_inspection__edit_form',
                description: 'View/edit form button',
                defaultMessage: 'View/Edit DOT vehicle inspection form'
            },                
            dot_inspection__save_continue: {
                id: 'dot_inspection__save_continue',
                description: 'Save and continue button',
                defaultMessage: 'Save and continue'
            },             
		});

        return (
            <div>
                <div className='dot_inspection_result_confirmation__title'>                
					<FormattedMessage {...messages.dot_inspection__title}/>
				</div>

                <div className='dot_inspection_result_confirmation__outer_box'>

                    <DotResult 
                        formData={this.props.formData}
                        setFormData={this.props.setFormData}
                        formValidationMessages={this.props.formValidationMessages}
                        onInspectionFailClick={this.props.onConfirmationFailClick}
						userLocale={this.props.userLocale}
						poCreationDate={this.props.poCreationDate}
						onInspectionDateChangeHandler={this.props.onInspectionDateChangeHandler}
                    />

					<div className='row dot_inspection_result_confirmation__row'>

						<div className='offset-sm-6 col-sm-6 dot_inspection_result_confirmation__col'>

							<div 
								className='dot_inspection_result_confirmation__edit_form_button' 							
								onClick={this.props.onEditDotFormClick}
							>
								<FormattedMessage {...messages.dot_inspection__edit_form}/>            
							</div>

						</div>

					</div>

                </div>          

                <div className='dot_inspection_result_confirmation__footer'>        					

					<div className='row dot_inspection_result_confirmation__row'>

						<div className='offset-sm-6 col-sm-6 dot_inspection_result_confirmation__col'>
						
							{ this.props.formData.get('hasInspectionPassed') !== false && 
								<div className='dot_inspection_result_confirmation__save_button' 
									onClick={this.props.onSaveConfirmationClick} 
								>
									<FormattedMessage {...messages.dot_inspection__save_continue}/>{' '}
									<img src='/assets/VMS_33button_add_blue.png' />
									<div className='dot_inspection_result_confirmation__spinner'>
										{this.props.isSaving &&
											<Spinner spinnerType='blue' />										
										}
									</div>
								</div>                        
							}

						</div>

					</div>                					

				</div>
            </div>
        );
    }
}

export default DotInspectionResultConfirmation;